export enum NotEligibleReason {
    None,
    TrialWasUsed,
    CreditCardWasUsed,
}

export interface ITrialEligibility {
    isEligible: boolean;
    notEligibleReason: NotEligibleReason;
    promoCode: string;
}
